module.exports = __webpack_public_path__ + "media/icons/inne-alerty-4e056883.png";